import { StyledTakeoverMainHeader } from './styled';

type TakeoverMainHeaderProps = {
  header: string;
};

export const TakeoverMainHeader = ({ header }: TakeoverMainHeaderProps) => {
  return (
    <StyledTakeoverMainHeader data-test="takeover-main-header">{header}</StyledTakeoverMainHeader>
  );
};
